import React from 'react'
import './styles.scss'
import { Button, Input, Select } from 'antd'
import classnames from 'classnames'

let validate = field => field !== undefined && field.length === 0

export default ({disabled, edit, setupForm, loadingSave, storages, billing_bucket, on_save, on_input_change, on_billing_bucket_change}) => (
  <div className={'add-aws'}>
    <h3>On-board existing account</h3>
    <div className="input-area">
      <div>
        <label>Storage account name*</label>
        <Input
          placeholder='enter storage account name' name='access_key_id' value={setupForm.access_key_id} disabled={edit}
          className={classnames({ 'required': validate(setupForm.access_key_id) })}
          onChange={on_input_change} />
        {validate(setupForm.access_key_id) && <span className='required'>Field is required.</span>}
      </div>

      <div>
        <label>Account key*</label>
        <Input
          type={edit ? 'password' : 'text'} placeholder='enter account key' name='secret_access_key' value={setupForm.secret_access_key} disabled={edit}
          className={classnames({ 'required': validate(setupForm.secret_access_key) })}
          onChange={on_input_change} />
        {validate(setupForm.secret_access_key) && <span className='required'>Field is required.</span>}
      </div>

      {
        (edit && storages && storages.length > 0)  ?
          <div>
            <label>Billing Bucket</label>
            <Select
              value      ={billing_bucket}
              onChange   ={on_billing_bucket_change} dropdownMatchSelectWidth={false}
              placeholder={'Select billing_bucket'}>
              {storages.map(s =>
                <Select.Option key={s.id} value={s.bucket_name}>
                  {s.bucket_name}
                </Select.Option>)}
            </Select>
          </div>:null
      }

      <div>
        <label>Give it a name*</label>
        <Input
          placeholder='enter account name' name='project_name' value={setupForm.project_name}
          className={classnames({ 'required': validate(setupForm.project_name) })}
          onChange={on_input_change} />
        {validate(setupForm.project_name) && <span className='required'>It's always good to give a name to your cloud service, so you can organize them better.</span>}
      </div>
    </div>

    <div className='footer'>
      <Button
        type='primary'
        disabled={disabled}
        loading={loadingSave}
        onClick={on_save}>
          Apply
      </Button>
    </div>
  </div>
)
